var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "query-filter",
    {
      attrs: {
        loading: _vm.loading,
        applyable: _vm.validPeriod,
        clearable: "",
      },
      on: {
        apply: function ($event) {
          return _vm.$emit("submit", _vm.params)
        },
        clear: function ($event) {
          return _vm.$emit("clear")
        },
      },
    },
    [
      _c("div", { staticClass: "d-flex align-baseline justify-center" }, [
        _c("div", { staticClass: "mx-2" }, [_vm._v(_vm._s(_vm.$t("period")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mx-2" },
          [
            _c("month-field", {
              attrs: { "data-testid": "event-period-from" },
              model: {
                value: _vm.params.from,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "from", $$v)
                },
                expression: "params.from",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mx-2" }, [_vm._v("〜")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mx-2" },
          [
            _c("month-field", {
              attrs: { "data-testid": "event-period-to" },
              model: {
                value: _vm.params.to,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "to", $$v)
                },
                expression: "params.to",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-center justify-center" }, [
        _c("div", { staticClass: "error--text" }, [
          _vm.errorMessage
            ? _c("p", { staticClass: "mt-2 mb-0" }, [
                _vm._v(_vm._s(_vm.errorMessage)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }